import ContactUs from "../pages/contactus";
import Home from "../pages/home";
import Instructors from "../pages/instructors";
import Training from "../pages/instructors/training";
import InstructorDetail from "../pages/instructors/instructordetail";
import PricingClass from "../pages/instructors/pricingClass";
import Shuffle from "../pages/instructors/shuffle";
import Schedule from "../pages/schedule";
import Video from "../pages/video";

export const routes = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/instructors",
    element: <Instructors />,
  },
  {
    path: "/instructors/:name",
    element: <InstructorDetail />,
  },
  {
    path: "/video",
    element: <Video />,
  },
  {
    path: "/pricingClass",
    element: <PricingClass />,
  },
  {
    path: "/shuffle",
    element: <Shuffle />,
  },
  {
    path: "/training",
    element: <Training />,
  },
  {
    path: "/schedule",
    element: <Schedule />,
  },
  {
    path: "/contactus",
    element: <ContactUs />,
  },
];
